(function () {
  'use strict';

  if (window.__lgpLoaded) return;
  window.__lgpLoaded = true;

  // ── Cache de variant IDs de muestras (se rellena en cuanto el div aparece) ──
  // Se usa por el interceptor ANTES de que el constructor haya terminado
  let _sampleVids = [];

  /* ── CSS ── */
  const CSS = `
#lgp-fab { position: fixed; left: 16px; bottom: 80px; z-index: 9998; display: none; }
#lgp-fab-btn { width: 90px; height: 90px; border-radius: 50%; background: #F0EDE6; border: none; cursor: pointer; box-shadow: 0 4px 16px rgba(0,0,0,.18); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px; position: relative; transition: transform .2s; animation: lgp-pulse 2.8s infinite; padding: 10px; }
#lgp-fab-btn:hover { transform: scale(1.06); }
.lgp-fab-text { font-size: 10px; font-weight: 700; letter-spacing: .13em; color: #1a1a1a; line-height: 1; font-family: inherit; }
#lgp-fab-badge { position: absolute; top: 5px; right: 5px; background: #C0392B; color: #fff; font-size: .62rem; font-weight: 700; width: 18px; height: 18px; border-radius: 50%; display: flex; align-items: center; justify-content: center; pointer-events: none; }
@keyframes lgp-pulse { 0%,100% { box-shadow: 0 4px 16px rgba(0,0,0,.18); } 50% { box-shadow: 0 6px 24px rgba(0,0,0,.28), 0 0 0 6px rgba(240,237,230,.5); } }
.lgp-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.5); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 1rem; }
.lgp-modal { background: #fff; border-radius: 14px; padding: 1.5rem; max-width: 460px; width: 100%; max-height: 82vh; overflow-y: auto; position: relative; }
.lgp-modal-close { position: absolute; top: .9rem; right: .9rem; background: none; border: none; font-size: 1.2rem; cursor: pointer; color: #666; line-height: 1; padding: .2rem; }
.lgp-modal-title { font-size: 1.05rem; font-weight: 700; margin: 0 0 .2rem; padding-right: 2rem; }
.lgp-modal-sub { font-size: .83rem; color: #666; margin: 0 0 1rem; }
.lgp-pills { display: flex; gap: .5rem; margin-bottom: 1rem; }
.lgp-pill { flex: 1; padding: .45rem .5rem; border-radius: 6px; border: 2px dashed #ccc; text-align: center; font-size: .75rem; color: #999; cursor: pointer; transition: all .15s; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.lgp-pill--filled { border-style: solid; border-color: #1a1a1a; color: #1a1a1a; font-weight: 600; }
.lgp-pill--active { background: #f0f0f0; border-color: #1a1a1a; border-style: solid; }
.lgp-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(118px, 1fr)); gap: .65rem; }
.lgp-item { border: 2px solid #e0e0e0; border-radius: 9px; padding: .7rem; cursor: pointer; background: #fff; text-align: center; display: flex; flex-direction: column; align-items: center; gap: .35rem; transition: border-color .15s; }
.lgp-item:hover:not([disabled]) { border-color: #1a1a1a; }
.lgp-item--selected { border-color: #1a1a1a; background: #f7f7f7; }
.lgp-item--unavail { opacity: .38; cursor: not-allowed; }
.lgp-item img { width: 78px; height: 78px; object-fit: cover; border-radius: 5px; }
.lgp-item span { font-size: .75rem; line-height: 1.3; }
`;

  /* ── Strings ── */
  const STRINGS = {
    es: { fab_top: 'MUESTRA', fab_bottom: 'GRATIS',   modal_title: '🎁 Elige tus muestras gratuitas',        sub_one: 'Tienes <strong>1 muestra gratis</strong> desbloqueada',       sub_many: 'Tienes <strong>{n} muestras gratis</strong> desbloqueadas',   slot_empty: 'Elige muestra',   unavailable: 'Sin stock' },
    ca: { fab_top: 'MOSTRA',  fab_bottom: 'GRATIS',   modal_title: '🎁 Tria les teves mostres gratuïtes',    sub_one: 'Tens <strong>1 mostra gratuïta</strong> desbloqueada',        sub_many: 'Tens <strong>{n} mostres gratuïtes</strong> desbloqueades',   slot_empty: 'Tria mostra',     unavailable: 'Sense estoc' },
    en: { fab_top: 'FREE',    fab_bottom: 'SAMPLE',   modal_title: '🎁 Choose your free samples',            sub_one: 'You have <strong>1 free sample</strong> unlocked',            sub_many: 'You have <strong>{n} free samples</strong> unlocked',         slot_empty: 'Choose sample',   unavailable: 'Out of stock' },
    fr: { fab_top: 'ÉCHAN-',  fab_bottom: 'TILLON',   modal_title: '🎁 Choisissez vos échantillons gratuits',sub_one: 'Vous avez <strong>1 échantillon gratuit</strong> débloqué',    sub_many: 'Vous avez <strong>{n} échantillons gratuits</strong> débloqués',slot_empty: 'Choisir',        unavailable: 'Rupture de stock' },
    it: { fab_top: 'CAMPIO-', fab_bottom: 'NE FREE',  modal_title: '🎁 Scegli i tuoi campioni gratuiti',     sub_one: 'Hai <strong>1 campione gratuito</strong> sbloccato',           sub_many: 'Hai <strong>{n} campioni gratuiti</strong> sbloccati',         slot_empty: 'Scegli',          unavailable: 'Non disponibile' },
    pt: { fab_top: 'AMOSTRA', fab_bottom: 'GRÁTIS',   modal_title: '🎁 Escolhe as tuas amostras gratuitas',  sub_one: 'Tens <strong>1 amostra gratuita</strong> desbloqueada',        sub_many: 'Tens <strong>{n} amostras gratuitas</strong> desbloqueadas',   slot_empty: 'Escolher',        unavailable: 'Sem stock' }
  };

  function injectCSS() {
    if (document.getElementById('lgp-styles')) return;
    const s = document.createElement('style');
    s.id = 'lgp-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ── Fetch interceptor (before _origFetch is set) ── */
  const _origFetch = window.fetch.bind(window);
  let _enforcing = false;
  let _ourAdd = false; // flag: we are the ones adding

  /* ── Theme cart refresh ── */
  async function notifyTheme() {
    // 1. Dispatch events common themes listen to
    ['cart:updated', 'cart:refresh'].forEach(name => {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      window.dispatchEvent(new CustomEvent(name));
    });

    // 2. Section Rendering API — re-render cart sections Horizon uses
    const sectionIds = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(el => {
      const id = el.id.replace('shopify-section-', '');
      if (/cart|header/i.test(id)) sectionIds.push(id);
    });
    if (sectionIds.length === 0) return;
    try {
      const res = await _origFetch(`/?sections=${sectionIds.join(',')}`);
      const data = await res.json();
      Object.entries(data).forEach(([id, html]) => {
        const wrapper = document.getElementById(`shopify-section-${id}`);
        if (wrapper) wrapper.innerHTML = html;
      });
    } catch {}
  }

  /* ── Main class ── */
  class LaromeGiftPicker {
    constructor() {
      const dataEl = document.getElementById('larome-gift-data');
      if (!dataEl) return;
      this.threshold = parseFloat(dataEl.dataset.threshold) || 20;
      this.maxGifts  = parseInt(dataEl.dataset.maxGifts)   || 2;
      this.locale    = (dataEl.dataset.locale || 'es').split('-')[0].toLowerCase();
      this.s         = STRINGS[this.locale] || STRINGS.es;
      try { this.samples = JSON.parse(dataEl.querySelector('script').textContent); }
      catch { this.samples = []; }
      this.cart       = null;
      this.activeSlot = 0;
      this.createFAB();
      this.init();
    }

    t(key, vars = {}) {
      let str = this.s[key] || key;
      Object.entries(vars).forEach(([k, v]) => { str = str.replaceAll(`{${k}}`, v); });
      return str;
    }

    async init() {
      await this.refreshCart();
      await this.enforceGiftLimit();
      this.updateFAB();
    }

    async refreshCart() {
      const res = await _origFetch('/cart.js');
      this.cart = await res.json();
    }

    get giftItems() {
      if (!this.cart) return [];
      return this.cart.items.filter(i => i.properties?.['_is_gift'] === 'true');
    }

    get nonGiftTotal() {
      if (!this.cart) return 0;
      const giftKeys = this.giftItems.map(i => i.key);
      return this.cart.items
        .filter(i => !giftKeys.includes(i.key))
        .reduce((s, i) => s + i.line_price, 0) / 100;
    }

    get earnedSlots() {
      return Math.min(Math.floor(this.nonGiftTotal / this.threshold), this.maxGifts);
    }

    // Total de unidades de muestra en el carrito (no líneas)
    get giftCount() {
      return this.giftItems.reduce((s, i) => s + i.quantity, 0);
    }

    get pendingSlots() {
      return Math.max(0, this.earnedSlots - this.giftCount);
    }

    createFAB() {
      if (document.getElementById('lgp-fab')) return;
      const fab = document.createElement('div');
      fab.id = 'lgp-fab';
      fab.innerHTML = `<button id="lgp-fab-btn" aria-label="Muestras gratuitas">
  <span class="lgp-fab-text">${this.t('fab_top')}</span>
  <span style="font-size:1.6rem;line-height:1;">🎁</span>
  <span class="lgp-fab-text">${this.t('fab_bottom')}</span>
  <span id="lgp-fab-badge">1</span>
</button>`;
      document.body.appendChild(fab);
      document.getElementById('lgp-fab-btn').addEventListener('click', () => this.showModal());
    }

    updateFAB() {
      const fab   = document.getElementById('lgp-fab');
      if (!fab) return;
      const pending = this.pendingSlots;
      fab.style.display = pending > 0 ? 'block' : 'none';
      const badge = document.getElementById('lgp-fab-badge');
      if (badge) badge.textContent = pending;
    }

    showModal() {
      this.activeSlot = this.giftItems.length < this.earnedSlots ? this.giftItems.length : 0;
      this.renderModal();
    }

    renderModal() {
      document.getElementById('lgp-modal')?.remove();
      const earned = this.earnedSlots;

      // Expandir quantity en slots individuales: [sampleA, sampleA, sampleB]
      const selectedVids = [];
      for (const item of this.giftItems) {
        for (let q = 0; q < item.quantity; q++) selectedVids.push(item.variant_id);
      }
      const activeVid = selectedVids[this.activeSlot] || null;

      let pillsHTML = '';
      if (earned > 1) {
        for (let i = 0; i < earned; i++) {
          const vid    = selectedVids[i] || null;
          const sample = vid ? this.samples.find(s => s.variantId == vid) : null;
          pillsHTML += `<div class="lgp-pill${sample ? ' lgp-pill--filled' : ''}${i === this.activeSlot ? ' lgp-pill--active' : ''}" data-slot="${i}">
            ${sample ? sample.title : this.t('slot_empty')}
          </div>`;
        }
      }

      const itemsHTML  = this.samples.map(s => {
        const isSelected = s.variantId == activeVid;
        const disabled   = !s.available;
        return `<button class="lgp-item${disabled ? ' lgp-item--unavail' : ''}${isSelected ? ' lgp-item--selected' : ''}"
          data-variant="${s.variantId}" ${disabled ? 'disabled' : ''}>
          <img src="${s.image}" alt="${s.title}">
          <span>${s.title}</span>
          ${!s.available ? `<small style="color:#aaa">${this.t('unavailable')}</small>` : ''}
        </button>`;
      }).join('');

      document.body.insertAdjacentHTML('beforeend', `
        <div id="lgp-modal" class="lgp-overlay">
          <div class="lgp-modal">
            <button class="lgp-modal-close" id="lgp-close">✕</button>
            <h4 class="lgp-modal-title">${this.t('modal_title')}</h4>
            <p class="lgp-modal-sub">${earned === 1 ? this.t('sub_one') : this.t('sub_many', { n: earned })}</p>
            ${pillsHTML ? `<div class="lgp-pills">${pillsHTML}</div>` : ''}
            <div class="lgp-grid">${itemsHTML}</div>
          </div>
        </div>`);

      document.getElementById('lgp-close').onclick = () => this.closeModal();
      document.getElementById('lgp-modal').addEventListener('click', e => {
        if (e.target.id === 'lgp-modal') this.closeModal();
      });
      document.querySelectorAll('.lgp-pill').forEach(pill => {
        pill.addEventListener('click', () => { this.activeSlot = parseInt(pill.dataset.slot); this.renderModal(); });
      });
      document.querySelectorAll('.lgp-item:not([disabled])').forEach(btn => {
        btn.addEventListener('click', async () => {
          const newVid     = parseInt(btn.dataset.variant);
          const currentVid = this.giftItems[this.activeSlot]?.variant_id;
          document.getElementById('lgp-modal')?.remove();
          if (currentVid && currentVid !== newVid) await this.removeSample(currentVid, false);
          await this.addSample(newVid);
          if (this.pendingSlots > 0) { this.activeSlot = this.giftItems.length; this.renderModal(); }
          else this.updateFAB();
        });
      });
    }

    async closeModal() {
      document.getElementById('lgp-modal')?.remove();
      if (this.pendingSlots > 0 && this.samples.length > 0) await this.autoFillRandom();
      this.updateFAB();
    }

    async autoFillRandom() {
      const available = this.samples.filter(s => s.available);
      const needed    = this.earnedSlots - this.giftCount;
      for (let i = 0; i < needed && available.length > 0; i++) {
        const idx    = Math.floor(Math.random() * available.length);
        const sample = available.splice(idx, 1)[0];
        await this.addSample(sample.variantId);
      }
    }

    async enforceGiftLimit(andNotify = false) {
      if (!this.cart) return;
      const sampleVids = this.samples.map(s => s.variantId);
      let changed = false;

      // 1. Remove samples added without _is_gift (directly from storefront)
      const unauthorized = this.cart.items.filter(i =>
        sampleVids.includes(i.variant_id) && i.properties?.['_is_gift'] !== 'true'
      );
      for (const item of unauthorized) {
        await _origFetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
        changed = true;
      }

      // 2. Remove excess legitimate gifts (por unidades, no por líneas)
      let excess = this.giftCount - this.earnedSlots;
      if (excess > 0) {
        for (const item of [...this.giftItems].reverse()) {
          if (excess <= 0) break;
          const remove = Math.min(excess, item.quantity);
          await _origFetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: item.quantity - remove })
          });
          excess -= remove;
          changed = true;
        }
      }

      if (changed) {
        await this.refreshCart();
        if (andNotify) await notifyTheme();
      }
    }

    async addSample(variantId) {
      _ourAdd = true;
      await _origFetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _is_gift: 'true' } }] })
      });
      _ourAdd = false;
      await this.refreshCart();
      await notifyTheme(); // ← refresh theme cart drawer
    }

    async removeSample(variantId, andNotify = true) {
      const item = this.cart.items.find(i => i.variant_id === variantId && i.properties?.['_is_gift'] === 'true');
      if (!item) return;
      // Decrementar en 1 (no borrar la línea entera si hay quantity > 1)
      await _origFetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: Math.max(0, item.quantity - 1) })
      });
      await this.refreshCart();
      if (andNotify) { await notifyTheme(); this.updateFAB(); }
    }
  }

  /* ── Helper: extrae variant IDs de cualquier formato de body ── */
  function extractVariantIds(body) {
    try {
      if (!body) return [];
      // JSON string: {"items":[{"id":123}]} o {"id":123}
      if (typeof body === 'string') {
        const p = JSON.parse(body);
        const items = p.items || (p.id ? [p] : []);
        return items.map(i => parseInt(i.id)).filter(Boolean);
      }
      // FormData / URLSearchParams
      if (body instanceof FormData || body instanceof URLSearchParams) {
        const ids = [];
        const id = body.get('id');
        if (id) ids.push(parseInt(id));
        // formato items[0][id]
        for (let i = 0; body.get(`items[${i}][id]`); i++) {
          ids.push(parseInt(body.get(`items[${i}][id]`)));
        }
        return ids.filter(Boolean);
      }
    } catch {}
    return [];
  }

  // Usa _sampleVids (cacheado en module scope), no depende del constructor
  function isSampleBlocked(body) {
    if (_ourAdd || !_sampleVids.length) return false;
    return extractVariantIds(body).some(id => _sampleVids.includes(id));
  }

  // Desactiva los botones de añadir al carrito de las muestras (drawer y PDP)
  function disableSampleButtons() {
    if (!_sampleVids.length) return;
    const vidsStr = _sampleVids.map(String);
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      const input = form.querySelector('input[name="id"]');
      if (input && vidsStr.includes(input.value)) {
        form.querySelectorAll('[type="submit"], button:not([type="button"])').forEach(btn => {
          btn.disabled = true;
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.4';
        });
      }
    });
    // Botones con data-variant-id (Horizon drawer)
    document.querySelectorAll('[data-variant-id]').forEach(el => {
      if (vidsStr.includes(String(el.dataset.variantId))) {
        el.disabled = true;
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.4';
      }
    });
  }

  /* ── Fetch interceptor: BLOCK sample additions from storefront ── */
  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');

    if (/\/cart\/add(\.js)?/.test(url) && isSampleBlocked(args[1]?.body)) {
      return new Response(
        JSON.stringify({ status: 422, description: 'Este producto no está disponible para compra directa.', errors: {} }),
        { status: 422, headers: { 'Content-Type': 'application/json' } }
      );
    }

    const result = await _origFetch(...args);

    if (/\/cart\/(add|change|update)(\.js)?/.test(url) && !_ourAdd && !_enforcing) {
      setTimeout(async () => {
        const picker = window.__lgpInstance;
        if (!picker || _enforcing) return;
        _enforcing = true;
        try {
          await picker.refreshCart();
          await picker.enforceGiftLimit(true);
          picker.updateFAB();
        } finally { _enforcing = false; }
      }, 200);
    }

    return result;
  };

  /* ── XHR interceptor: cubre temas que usan XMLHttpRequest ── */
  const _OrigXHR = window.XMLHttpRequest;
  window.XMLHttpRequest = class extends _OrigXHR {
    open(method, url, ...rest) {
      this._lgpMethod = method;
      this._lgpUrl   = url;
      return super.open(method, url, ...rest);
    }
    send(body) {
      if (this._lgpMethod === 'POST' && /\/cart\/add(\.js)?/.test(this._lgpUrl) && isSampleBlocked(body)) {
        // Fake 422 without hitting the server
        Object.defineProperty(this, 'status',       { value: 422 });
        Object.defineProperty(this, 'responseText', { value: JSON.stringify({ status: 422, description: 'No disponible' }) });
        setTimeout(() => {
          this.dispatchEvent(Object.assign(new Event('load'), { target: this }));
          if (typeof this.onload === 'function') this.onload();
        }, 0);
        return;
      }
      return super.send(body);
    }
  };

  /* ── Boot ── */
  function boot() {
    try { window.__lgpInstance = new LaromeGiftPicker(); } catch (e) { console.warn('[GiftPicker]', e); }
  }

  injectCSS();

  function tryBoot() {
    const dataEl = document.getElementById('larome-gift-data');
    if (dataEl) {
      // Cachear VIDs ANTES del constructor para que el interceptor ya los tenga
      try {
        const samples = JSON.parse(dataEl.querySelector('script').textContent);
        _sampleVids = samples.map(s => s.variantId);
      } catch {}
      disableSampleButtons();
      boot();
    } else {
      const obs = new MutationObserver(() => {
        const el = document.getElementById('larome-gift-data');
        if (el) {
          obs.disconnect();
          try {
            const samples = JSON.parse(el.querySelector('script').textContent);
            _sampleVids = samples.map(s => s.variantId);
          } catch {}
          disableSampleButtons();
          boot();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', tryBoot)
    : tryBoot();

  // Re-deshabilitar botones cuando el drawer inyecta nuevo HTML
  new MutationObserver(disableSampleButtons)
    .observe(document.body, { childList: true, subtree: true });

  /* ── Polling: detecta cambios de carrito cada 3s (importe sube/baja) ── */
  let _lastToken = null;
  setInterval(async () => {
    if (_enforcing || _ourAdd) return;
    try {
      const res  = await _origFetch('/cart.js');
      const cart = await res.json();
      const token = `${cart.item_count}:${cart.total_price}`;
      if (_lastToken !== null && _lastToken !== token) {
        const picker = window.__lgpInstance;
        if (picker) {
          picker.cart = cart;
          _enforcing = true;
          try {
            await picker.enforceGiftLimit(true);
            picker.updateFAB();
          } finally { _enforcing = false; }
        }
      }
      _lastToken = token;
    } catch {}
  }, 3000);

})();
